import './ticket_view.js.coffee';# Added by Script 

Customer.Ticket ||= {}

class Customer.Ticket.WhatsappTicketView extends Customer.Ticket.TicketView

  initialize: (@options = {}) ->
    super(@options)
    @interactionsView = new Customer.Ticket.WhatsappInteractionsView(_.extend(@options, {ticketView: @}))
    @listenTo(@interactionsView, 'clicked:user', @onClickUser)

  render: ->
    super
    @_checkTimeWindow()
    @

  beforeAdjustHeight: ->
    super
    #Hack main response box behaviour for user grouped tickets
    @renderResponse()
    @showResponse()

  onResponse: (response) =>
    super
    #Hack main response box behaviour for user grouped tickets
    @renderResponse()

  _renderResponse: ->
    responseOptions = {
      socialAccounts: @options.socialAccounts
      ticketView: @
      notes: true
      responseTemplates: @responseTemplates
      tags: @model.getInteractionToResponse().tags()
      mainResponse: true
      responseTo: @model.getInteractionIdToResponse()
    }
    @responseView = new Customer.Dashboard.WhatsappTicketResponseView(responseOptions)

    @listenTo(@responseView, 'note:saved', (content) => @model.get('notes').create({content: content}, wait: true))
    @responseView.bind('onResponse', @onResponse)
    @responseView.bind('response:success', @onResponse)
    @responseView.bind('response:error', @onResponse)
    @responseView.bind('response:destroy', @onResponseDestroy)
    @responseView.render()

  renderNew: (interactions, ticket_lock_version) =>
    super(interactions, ticket_lock_version)
    _.every(interactions, (iv) =>
      if iv.viewType == 'interaction'
        if !iv.isBrandContent()
          @model.set({'last_user_interaction_date': iv.created_at()})
          @_enableResponseControls()
    )


  _checkTimeWindow :->
    MINUTE = 1000 * 60
    DAY_MINUTES = 60 * 24
    last_date = new Date(@model.get('last_user_interaction_date'))
    now = new Date()
    min_passed = Math.round((now.getTime() - last_date.getTime()) / MINUTE )
    if (min_passed >= DAY_MINUTES)
      @_disableResponseControls()

  _disableResponseControls: ->
    return unless @responseView
    @responseView.showResponseWarning()
    @responseView._disableResponseTextArea()
    @responseView._disableResponseButtons()
    @responseView.disableAttachmentButton()
    @responseView._disablePredefinedResponseButton()
    @responseView._disableExpandResponseButton()
    @responseView._disableEmojiPicker()
    @responseView._disableLinkShortener()

  _enableResponseControls: ->
    return unless @responseView
    @responseView.hideResponseWarning()
    @responseView._enableResponseTextArea()
    @responseView._enableResponseButtons()
    @responseView.enableAttachmentButton()
    @responseView._enablePredefinedResponseButton()
    @responseView._enableExpandResponseButton()
    @responseView._enableEmojiPicker()
    @responseView._enableLinkShortener()
